import React, { createContext, useContext, useEffect, useState } from 'react';

export type AppLang = 'en' | 'he';
export type AppDir  = 'ltr' | 'rtl';

interface DirectionCtx {
  lang: AppLang;
  dir: AppDir;
  toggleLang: () => void;
}

const DirectionContext = createContext<DirectionCtx>({
  lang: 'en',
  dir: 'ltr',
  toggleLang: () => {},
});

const STORAGE_KEY = 'opselect_lang';

function getInitialLang(): AppLang {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (s === 'en' || s === 'he') return s;
  } catch { /* ignore */ }
  return 'en';
}

export const DirectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<AppLang>(getInitialLang);
  const dir: AppDir = lang === 'he' ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.dir  = dir;
    document.documentElement.lang = lang;
    try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* ignore */ }
  }, [lang, dir]);

  const toggleLang = () => setLang(l => (l === 'he' ? 'en' : 'he'));

  return (
    <DirectionContext.Provider value={{ lang, dir, toggleLang }}>
      {children}
    </DirectionContext.Provider>
  );
};

export const useDirection = () => useContext(DirectionContext);
